// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"Checkbox_checkboxWrapper__yfq5d","checkboxInput":"Checkbox_checkboxInput__iDZPs","checkboxLabel":"Checkbox_checkboxLabel__Eudau"};